/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

export const WEBHOOKS_LOG_PATH = "/settings/webhooks/logs/:id";
